import React, { useState, useEffect } from 'react';
import './PasswordGate.css';

const PasswordGate = ({ onPasswordSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [authenticated, setAuthenticated] = useState(false);
  
  // Check if already authenticated via localStorage
  useEffect(() => {
    const isAuthenticated = localStorage.getItem('siteAuthenticated') === 'true';
    if (isAuthenticated) {
      setAuthenticated(true);
      onPasswordSuccess();
    }
  }, [onPasswordSuccess]);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Replace 'yogasite2023' with your desired password
    const correctPassword = 'dychame';
    
    if (password === correctPassword) {
      // Save authentication to localStorage
      localStorage.setItem('siteAuthenticated', 'true');
      setAuthenticated(true);
      onPasswordSuccess();
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };
  
  if (authenticated) {
    return null; // Don't render anything once authenticated
  }
  
  return (
    <div className="password-gate">
      <div className="password-container">
        <div className="password-form-container">
          <h1>Welcome to TiDea Solis</h1>
          <p>This site is currently under development and requires a password to access.</p>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter site password"
                required
              />
            </div>
            
            {error && <div className="error-message">{error}</div>}
            
            <button type="submit" className="btn-submit">
              Enter Site
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PasswordGate; 